/**
 * LocalStorage and SessionStorage keys used throughout the application.
 * Centralized to prevent typos and ensure consistency.
 */

/** User identification and preferences */
export const USER_ID_KEY = "chat_user_id" as const;
export const USER_NAME_KEY = "chat_user_name" as const;

/** UI state persistence */
export const OPEN_PAGE_KEY = "open_page" as const;


/** Article caching (Gebreken/Bouwbesluit) */
export const ARTICLE_CACHE_KEY = "article_preload_cache" as const;
export const ARTICLE_CACHE_VERSION = "v1" as const;

/** Thread management */
export const CURRENT_CONVERSATION_IDENTIFIER = "currentThreadId" as const;
export const conversation_access_times_KEY = "conversation_access_times" as const;
export const THREAD_MESSAGE_PREFIX = "thread_messages_" as const;
